import React, { FC } from "react";

import { Translate } from "@/app/application/Translate";
import { CheckboxState } from "@/features/training/ui";
import {
	Box,
	Checkbox,
	FormControlLabel,
	FormGroup,
	FormLabel,
	styled,
} from "@mui/material";
import FormControl from "@mui/material/FormControl";
import Typography from "@mui/material/Typography";

const StyledBox = styled(Box)(({ theme }) => ({
	display: "flex",
	padding: "20px 20px 0 20px",
	border: `1px solid ${theme.palette.divider}`,
	borderRadius: theme.shape.borderRadius * 2,
}));

interface KpiCheckboxesGroupProps {
	checkboxesState: Record<number, CheckboxState> | undefined;
	setCheckboxesState: React.Dispatch<
		React.SetStateAction<Record<number, CheckboxState>>
	>;
}

export const KpiCheckboxesGroup: FC<KpiCheckboxesGroupProps> = (props) => {
	const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		const state = props.checkboxesState ?? {};
		const key = event.target.name;
		props.setCheckboxesState({
			...state,
			[key]: {
				...state[key as unknown as number],
				checked: event.target.checked,
			},
		});
	};

	const state = props.checkboxesState ?? {};
	if (Object.keys(state).length === 0) return null;

	return (
		<StyledBox
			sx={{
				maxHeight: "600px",
				overflow: "auto",
				border: "1px solid #ccc",
				borderRadius: "4px",
				minHeight: "36px",
			}}
		>
			<FormControl
				sx={{ width: "100%" }}
				component="fieldset"
				variant="standard"
			>
				<FormLabel
					component="legend"
					sx={{ width: "100%", color: "text.primary" }}
				>
					<Box component="span" sx={{ float: "left" }}>
						<Translate String="Training.Drills.NewDrill.KpiParameter">
							Kpi Parameters
						</Translate>
					</Box>
					<Box component="span" sx={{ float: "right", marginBottom: 2 }}>
						<Translate String="Training.Drills.NewDrill.MaxValue">
							Max Value
						</Translate>
					</Box>
				</FormLabel>
				<FormGroup>
					{Object.values(state).map((kpi) => (
						<Box key={kpi.Id} display="flex" justifyContent="space-between">
							<FormControlLabel
								control={
									<Checkbox
										checked={kpi.checked}
										onChange={handleChange}
										name={String(kpi.Id)}
									/>
								}
								label={kpi.Name}
								sx={{
									"& .MuiFormControlLabel-label": { color: "text.primary" },
								}}
							/>
							<Typography
								sx={{
									textAlign: "center",
									float: "right",
									color: "text.primary",
								}}
							>
								{kpi.MaxValue}
							</Typography>
						</Box>
					))}
				</FormGroup>
			</FormControl>
		</StyledBox>
	);
};
